export default function WhyTrustUs() {
  const points = [
    {
      icon: 'ri-microscope-fill',
      color: 'text-cyan-400',
      borderColor: 'border-cyan-500/20',
      glowColor: 'bg-cyan-500/10',
      title: 'Research-Based Recommendations',
      description: 'Every product is researched across dozens of verified reviews, benchmarks, and real user feedback before making our list.',
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      color: 'text-emerald-400',
      borderColor: 'border-emerald-500/20',
      glowColor: 'bg-emerald-500/10',
      title: 'Focus on Value for Money',
      description: 'We prioritize products that deliver the best performance per dollar, not just the most expensive options.',
    },
    {
      icon: 'ri-shield-check-fill',
      color: 'text-purple-400',
      borderColor: 'border-purple-500/20',
      glowColor: 'bg-purple-500/10',
      title: 'No Sponsored Bias',
      description: 'Our picks are never influenced by brand deals or sponsorships. What we recommend, we genuinely believe in.',
    },
    {
      icon: 'ri-refresh-line',
      color: 'text-amber-400',
      borderColor: 'border-amber-500/20',
      glowColor: 'bg-amber-500/10',
      title: 'Regularly Updated Picks',
      description: 'Tech moves fast. We revisit and refresh our buying guides whenever better options hit the market.',
    },
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background ambient */}
      <div className="absolute inset-0 bg-purple-900/5 pointer-events-none"></div>
      {/* Glow blobs */}
      <div className="absolute top-8 right-[12%] w-72 h-72 bg-purple-600/7 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-8 left-[10%] w-56 h-56 bg-cyan-500/6 rounded-full blur-3xl pointer-events-none"></div>
      {/* Sparse floating dots */}
      {[...Array(7)].map((_, i) => (
        <div
          key={i}
          className={`absolute rounded-full animate-pulse pointer-events-none ${i % 2 === 0 ? 'w-1 h-1 bg-purple-400/35' : 'w-0.5 h-0.5 bg-cyan-400/35'}`}
          style={{
            left: `${(i * 15 + 3) % 94}%`,
            top: `${(i * 19 + 6) % 88}%`,
            animationDelay: `${(i * 0.5) % 3}s`,
            animationDuration: `${2 + (i * 0.25) % 2.5}s`,
          }}
        />
      ))}

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 border border-white/20 rounded-full text-xs uppercase tracking-widest text-white/80 backdrop-blur-sm bg-white/5 mb-4">
            <span className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse inline-block"></span>
            Trusted Reviews
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white">
            Why Trust Our Picks?
            <div className="h-1 w-32 bg-gradient-to-r from-purple-500 via-cyan-500 to-purple-500 mx-auto mt-4 rounded-full shadow-lg shadow-cyan-500/50"></div>
          </h2>
        </div>

        {/* Points grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {points.map((point, i) => (
            <div
              key={i}
              className={`relative rounded-xl border ${point.borderColor} p-6 backdrop-blur-sm transition-all duration-300 hover:scale-[1.02] hover:shadow-lg group`}
              style={{ background: 'rgba(0,0,0,0.35)' }}
            >
              {/* Icon */}
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${point.glowColor} border ${point.borderColor} mb-4`}>
                <i className={`${point.icon} text-2xl ${point.color}`}></i>
              </div>
              <h3 className={`text-base font-bold text-white mb-2 group-hover:${point.color} transition-colors duration-300`}>
                {point.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
